import { LoginForm } from '../../components/Auth/LoginForm'

export function Login() {
    return <LoginForm />
}
